// Local calendar helpers (browser time zone; the gateway interprets dates in the site time zone).

export function localDate(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function parseLocalDate(value: string): Date {
  const [y, m, d] = value.split('-').map(Number);
  return new Date(y!, m! - 1, d!);
}

export function shiftDate(
  value: string,
  period: 'day' | 'week' | 'month' | 'year',
  direction: 1 | -1,
): string {
  const date = parseLocalDate(value);
  switch (period) {
    case 'day':
      date.setDate(date.getDate() + direction);
      break;
    case 'week':
      date.setDate(date.getDate() + 7 * direction);
      break;
    case 'month':
      date.setDate(1);
      date.setMonth(date.getMonth() + direction);
      break;
    case 'year':
      date.setMonth(0, 1);
      date.setFullYear(date.getFullYear() + direction);
      break;
  }
  return localDate(date);
}

/** value for <input type="datetime-local"> */
export function toDateTimeLocal(date: Date): string {
  return `${localDate(date)}T${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
}

/** first day (YYYY-MM-DD) of the period containing the date; weeks start on Monday */
export function periodStart(value: string, period: 'day' | 'week' | 'month' | 'year'): string {
  const date = parseLocalDate(value);
  switch (period) {
    case 'day':
      break;
    case 'week':
      date.setDate(date.getDate() - ((date.getDay() + 6) % 7));
      break;
    case 'month':
      date.setDate(1);
      break;
    case 'year':
      date.setMonth(0, 1);
      break;
  }
  return localDate(date);
}
